import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import StrategicAdvisoryMentorship from "./sections/StrategicAdvisoryMentorship";
import GlobalStagePresence from "./sections/GlobalStagePresence";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <StrategicAdvisoryMentorship />
      <GlobalStagePresence />
      <Footer />
    </div>;
}